// import { useSelector } from "react-redux";


const OneAssistSync = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
      // console.log(OrgId, 'org_id__________')
      
      return (
        <div className="iframe-div">
            <iframe src= {`https://iiplwork.retool.com/embedded/public/9eeed3a2-dbf6-4411-a72b-9cd0de5ba8fb`}
            className="iframe-style"></iframe>
        </div>
      )
    };
    
    export default OneAssistSync;
    